import React, { useState, useContext } from 'react';
import {
    Toolbar,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Grid,
    Fab,
    Typography,
    Button
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { makeStyles } from '@material-ui/core/styles';
import { grey } from '@material-ui/core/colors';

import SideMenu from '../../components/SideMenu';
import InputSearch from '../../components/InputSearch';
import Popup from '../../components/Popup';
import Alert from '../../components/Alert';

import api from '../../services/api';
import { PermissionsContext } from '../../providers/Permissions';
import { ListPageHeading } from '../../components/ListPageLayout';

export default function PersonTypeList() {
    const classes = useStyles();

    const {
        PermissionWrapper,
        PermissionOneOfWrapper,
    } = useContext(PermissionsContext);

    const [personTypes, setPersonTypes] = useState([]);
    const [refresh, setRefresh] = useState(true)
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(0);
    const [limit, setLimit] = useState(10);
    const [message, setMessage] = useState({
        open: false,
        variant: '',
        text: '',
    });

    const closeMessage = () => {
        setMessage({
            open: false,
            variant: '',
            text: '',
        });
    };

    const [openDeletePopup, setOpenDeletePopup] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [deletingPersonTypeId, setDeletingPersonTypeId] = useState();
    const handleDelete = (id) => {
        setDeletingPersonTypeId(id);
        setOpenDeletePopup(true);
    }
    const deletePersonType = async (id) => {
        try {
            setIsDeleting(true);

            var PersonType;
            personTypes.forEach((element) => {
                if (element.id === deletingPersonTypeId) {
                    PersonType = element
                }
            })

            const result = await api.delete(`/person_type/delete/${deletingPersonTypeId}`);

            const { deletedPersonType } = result.data;

            setIsDeleting(false);

            if (deletedPersonType) {
                setDeletingPersonTypeId(null);
                setOpenDeletePopup(false);
                setRefresh(!refresh);
                setMessage({
                    open: true,
                    variant: 'success',
                    text: `Tipo de pessoa "${PersonType.name}" deletado com sucesso!`,
                });
            }
        } catch (err) {
            setIsDeleting(false);
            setMessage({
                open: true,
                variant: 'error',
                text: err.error,
            });
        }
    }

    function updateRequest({ search }) {

        const loadData = async () => {
            try {
                const result = await api.get('/person_type/list', {
                    params: {
                        search,
                        limit,
                        page,
                        show_exceptions: false,
                    },
                });

                const { count, personTypes } = result.data;

                setPersonTypes(personTypes);
                setTotal(count);
            }
            catch (err) {
                console.log(err);
            }
        };

        loadData();

    };

    const changePage = (_, newPage) => {
        setPage(newPage);
    };

    const quantityPerPage = ({ target }) => {
        setLimit(parseInt(target.value, 10));
        setPage(0);
    };

    return (
        <div className={classes.root}>
            <SideMenu />
            <main className={classes.content}>
                <Toolbar />
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <ListPageHeading icon="people" title="Tipos de Pessoas" />
                    </Grid>
                    
                    <Grid item xs={12}>
                        <div className={classes.tableCard}>
                            <div className={classes.cardHeader}>
                                <div>
                                    <Typography className={classes.cardTitle}>
                                        Tipos Cadastrados
                                    </Typography>
                                    <Typography className={classes.resultCount}>
                                        {   
                                            total === 0? 'Nenhum registro encontrado':
                                            !total ? 'Atualizando lista...'
                                            : `${total} ${total === 1
                                                ? 'registro encontrado'
                                                : 'registros encontrados'}`}
                                            
                                    </Typography>
                                </div>

                                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                    <InputSearch
                                        textFieldProps={{
                                            placeholder: 'Buscar por nome...',
                                            fullWidth: true,
                                            'aria-label': 'Buscar tipo de pessoa',
                                        }}
                                        request={updateRequest}
                                        pagination={[refresh, page, limit]}
                                        className={classes.inputSearch}
                                    />

                                </div>
                            </div>
                            <TableContainer component={Paper}>
                                <Table className={classes.table} size="small" aria-label="person type list">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className={classes.tableHead}>ID</TableCell>
                                            <TableCell className={classes.tableHead}>Nome</TableCell>
                                            <PermissionOneOfWrapper
                                                routes={[
                                                    "/tipo_de_pessoa/modificar/:id",
                                                    "/tipo_de_pessoa/deletar/:id",
                                                ]}
                                            >
                                                <TableCell className={classes.tableHead}>Ações</TableCell>
                                            </PermissionOneOfWrapper>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {!!personTypes && personTypes.map(current => (
                                            <TableRow key={current.id}>
                                                <TableCell className={classes.tableBody} component="th" scope="row">
                                                    {current.id}
                                                </TableCell>
                                                <TableCell className={classes.tableBody}>
                                                    {current.name}
                                                </TableCell>
                                                <PermissionOneOfWrapper
                                                    routes={[
                                                        "/tipo_de_pessoa/modificar/:id",
                                                        "/tipo_de_pessoa/deletar/:id",
                                                    ]}
                                                >
                                                    <TableCell className={classes.tableBody}>
                                                        <>
                                                            <PermissionWrapper route="/tipo_de_pessoa/modificar/:id">
                                                                <Button
                                                                    type="button"
                                                                    variant="contained"
                                                                    size="small"
                                                                    color="primary"
                                                                    className={classes.actionButton}
                                                                    href={`/tipo_de_pessoa/modificar/${current.id}`}
                                                                    id={`edit`}
                                                                >
                                                                    <EditIcon style={{ fontSize: 20 }} />
                                                                </Button>
                                                            </PermissionWrapper>
                                                            <PermissionWrapper route="/tipo_de_pessoa/deletar/:id">
                                                                <Button
                                                                    type="button"
                                                                    variant="contained"
                                                                    size="small"
                                                                    color="secondary"
                                                                    className={classes.actionButton}
                                                                    onClick={() => handleDelete(current.id)}
                                                                    id={`delete`}
                                                                >
                                                                    <DeleteIcon style={{ fontSize: 20 }} />
                                                                </Button>
                                                            </PermissionWrapper>
                                                        </>
                                                    </TableCell>
                                                </PermissionOneOfWrapper>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                        </div>
                        <TablePagination
                            rowsPerPageOptions={[10, 20, 30]}
                            component="div"
                            count={total}
                            rowsPerPage={limit}
                            page={page}
                            labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                            labelRowsPerPage="Registros por página"
                            onChangePage={changePage}
                            onChangeRowsPerPage={quantityPerPage}
                        />
                    </Grid>
                </Grid>
                <Popup
                    openPopup={openDeletePopup}
                    setOpenPopup={setOpenDeletePopup}


                >
                    <Grid container xs={12} style={{
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '0 3% 2% 3%',

                    }}>
                        <Typography variant='h5'
                            style={{
                                fontWeight: 'bold',
                                color: '#9e9e9e'
                            }}

                        >
                            Deseja mesmo deletar esse tipo de pessoa?
                        </Typography>
                        <Grid item style={{
                            marginTop: '50px'
                        }}>
                            <Button
                                disabled={isDeleting}
                                variant="contained"
                                onClick={() => deletePersonType()}
                                color="secondary"
                                endIcon={<DeleteIcon />}
                                id="confirm"
                            >
                                {isDeleting ? 'Deletando...' : 'Sim'}
                            </Button>
                        </Grid>
                    </Grid>
                </Popup>
                <PermissionWrapper route="/tipo_de_pessoa/criar">
                    <Fab
                        color="primary"
                        aria-label="add"
                        className={classes.fabButton}
                        href="/tipo_de_pessoa/criar"
                    >
                        <AddIcon />
                    </Fab>
                </PermissionWrapper>
                {!!message.open && (
                    <Alert
                        open={message.open}
                        autoHideDuration={6000}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                        severity={message.variant}
                        onClose={closeMessage}
                    >
                        {message.text}
                    </Alert>
                )}
            </main>
        </div>
    );
}

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        marginBottom: theme.spacing(6),
        marginTop: theme.spacing(5),
    },
    title: {
        color: 'rgba(6, 19, 31, 1)',
        fontSize: 28,
        fontWeight: 600,
    },
    cardTitle: {
        color: '#1f2937',
        fontSize: 16,
        fontWeight: 700,
    },
    resultCount: {
        color: '#9ca3af',
        fontSize: 12,
        marginTop: 2,
    },
    inputSearch: {
        width: 340,
        maxWidth: '100%',
        '& .MuiTextField-root': {
            width: '100%',
        },
        '& .MuiOutlinedInput-root': {
            minHeight: 40,
            borderRadius:20,
            backgroundColor: '#f9fafb',
            transition: 'background-color 160ms ease, box-shadow 160ms ease',
            '&:hover': {
                backgroundColor: '#fff',
            },
            '&.Mui-focused': {
                backgroundColor: '#fff',
                boxShadow: '0 0 0 3px rgba(37, 99, 235, 0.10)',
            },
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#dfe3e8',
        },
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    filterButton: {
        '&:hover': {
            backgroundColor: '#1e88e5',

        },
        borderRadius: 20,
        overflow: 'hidden',
    },

    tableCard: {
        overflow: 'hidden',
        border: '1px solid #e5e7eb',
        borderRadius: 16,
        backgroundColor: '#fff',
        boxShadow: '0 10px 30px rgba(15, 23, 42, 0.05)',
        
    },
    cardHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: theme.spacing(3),
        padding: theme.spacing(2.5, 3),
        borderBottom: '1px solid #e5e7eb',
        [theme.breakpoints.down('sm')]: {
            alignItems: 'stretch',
            flexDirection: 'column',
            gap: theme.spacing(2),
            padding: theme.spacing(2),
        },
    },
    table: {
        minWidth: 500,
        width: '100%',
    },
    tableHead: {
        borderBottom: '1px solid #e5e7eb',
        fontWeight: 700,
        textAlign: 'center',
        padding: '14px 10px',
        textTransform: 'uppercase',
        backgroundColor: '#f8fafc',
        color: '#64748b',
        letterSpacing: '0.06em',
        fontSize: 11,
        position: 'sticky',
        top: 0,
    },
    tableBody: {
        color: '#374151',
        padding: '14px 10px',
        textAlign: 'center',
        fontSize: 14,
        fontWeight: 600,
        borderBottom: '1px solid #eef1f5',
    },
    tableRow: {
        transition: 'background-color 0.2s ease, transform 0.2s ease',
        '&:hover': {
            backgroundColor: '#f3f6fb',
        }
    },
    fabButton: {
        position: 'fixed',
        bottom: 0,
        right: 0,
        margin: theme.spacing(3),
    },
    actionButton: {
        margin: theme.spacing(0, .5),
        padding: theme.spacing(.5, 0),
        minWidth: 30,
        borderRadius: 9,
    },
}));
